export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-18 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-5">关于贝勒漫画</h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
            贝勒漫画网创立于2020年，是专注于韩漫、日漫、国漫在线阅读的综合性平台。
            作为贝勒漫画官方入口，我们致力于为漫画爱好者提供稳定可靠的访问渠道和优质流畅的阅读体验。
          </p>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
            平台汇聚超过2000部热门漫画资源，涵盖恋爱、奇幻、动作、悬疑、校园、都市等多元题材，
            每日同步更新热门连载，确保读者第一时间获取最新内容。
          </p>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
            我们秉持正版授权理念，与多家国内外漫画版权方建立合作关系，
            同时提供网页版、移动端APP等多端适配方案，让读者随时随地畅享漫画世界。
          </p>

          <div className="flex flex-wrap justify-center gap-5 md:gap-10 text-center">
            <div>
              <div className="text-3xl font-bold text-primary-500">2020</div>
              <div className="text-xs text-foreground-500 mt-1">创立年份</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-primary-500">2000+</div>
              <div className="text-xs text-foreground-500 mt-1">漫画资源</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-primary-500">500万+</div>
              <div className="text-xs text-foreground-500 mt-1">月活跃读者</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-primary-500">正版授权</div>
              <div className="text-xs text-foreground-500 mt-1">内容合作</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}